export default __webpack_public_path__ + "static/media/1968.0f7cee65.png";